export enum RetailDashboardTypes {
  TOP_10_PRODUCTS = "TOP_10_PRODUCTS",
  MOP = "MOP",
  TOP_5_PRODUCTS_AND_REST = "TOP_5_PRODUCTS_AND_REST",
  PRODUCTS_BY_SITE_IN_TIMESERIES = "PRODUCTS_BY_SITE_IN_TIMESERIES",
}

export enum KPIDashboardTypes {
  KPI_TOTAL_TAX_AMOUNT = "KPI_TOTAL_TAX_AMOUNT",
  KPI_FUEL_PRODUCTS_TOTAL_VOLUME = "KPI_FUEL_PRODUCTS_TOTAL_VOLUME",
  KPI_NUMBER_OF_SALES = "KPI_NUMBER_OF_SALES",
  KPI_TOTAL_AMOUNT = "KPI_TOTAL_AMOUNT"
}
